export default {
    baseStyle: {
        heading: {
            fontSize: '16px',
            textTransform: 'uppercase'
        },
        headingLink: {
            color: 'gray.850',
            textDecoration: 'none',
            fontFamily: 'UniversLTStd, Arial, sans-serif',
            _hover: {
                textDecoration: 'none'
            }
        }
    }
}
